import auth from "../../../auth/auth-helper";

const CreateAtmTransaction = async (signal,credentials,transaction) => {
  console.log(auth.getuserType());
    try {
      let response = await fetch(
        process.env["REACT_APP_API_HOST"] + "/api/" + auth.getuserType() + "/atm/new",
        {
          method: "POST",
          signal: signal,
          headers:{
            'Accept':'application/json',
            'Content-Type':'application/json',
            'x-access-token':credentials
        },
        body:JSON.stringify(transaction)
        }
      );
      return await response.json();
    } catch (err) {
      console.log(err);
    }
  };

  export {CreateAtmTransaction};